import { render, staticRenderFns } from "./hz.vue?vue&type=template&id=5b2acd85&scoped=true"
var script = {}
import style0 from "./hz.vue?vue&type=style&index=0&id=5b2acd85&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2acd85",
  null
  
)

export default component.exports